module.exports = "<p>\n  fuses works!\n</p>\n"